import { render, staticRenderFns } from "./RelateServiceProfileList.vue?vue&type=template&id=7e3b8d2e&"
import script from "./RelateServiceProfileList.vue?vue&type=script&lang=js&"
export * from "./RelateServiceProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports